import Layout from "components/Layout";
import { NavBarCmsData } from "components/NavBar/interfaces";
import { EmtekPageProps } from "pages/[[...slug]]";

import { SplitLayoutSubPage } from "./SplitLayoutSubPage";
import { ToolboxBlock, ToolboxStreamfield } from "./Toolbox";

export type PageProps = EmtekPageProps<{
    split_layout_body: Array<ToolboxBlock>;
    split_layout_nav: NavBarCmsData | null;
}>;

const UtilityPage: React.FC<PageProps> = (props) => {
    return (
        <Layout metadata={props.wagtail} menus={props.menus}>
            <SplitLayoutSubPage nav={props.wagtail.split_layout_nav}>
                <ToolboxStreamfield
                    blocks={props.wagtail.split_layout_body}
                    firstBlock
                />
            </SplitLayoutSubPage>
        </Layout>
    );
};

export default UtilityPage;
